import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as TagIcon } from './tag.svg';

export const Tag = IconHOC(TagIcon);
